<div class="ds">

  <div class="ds-cabecera">
    <button type="button" class="ds-btn-volver"
            title="{{ 'BTN_REGRESAR' | translate }}" (click)="regresar()">
      <img src="assets/icons/ico-volver.svg" alt="">
    </button>

    <app-admsb-encabezado *ngIf="!cargandoPasarela" [idTercero]="idTercero" [idTitular]="idTitular"
                          [idSolicitudUnidadCredito]="idSolicitudUnidadCredito"
                          (titularCargado)="titular = $event">
    </app-admsb-encabezado>
  </div>

  <app-admsb-unidad-productiva *ngIf="!cargandoPasarela" [idSolicitudUCUnidadProductiva]="idSolicitudUCUnidadProductiva">
  </app-admsb-unidad-productiva>

  <!-- Tarjetas jerárquicas: Servicio > Canal > Método (Medios, Banner, Adjuntos, Contratos) -->
  <app-admsb-servicio-arbol *ngIf="!cargandoPasarela && idTitular" [idTitular]="idTitular">
  </app-admsb-servicio-arbol>

  <app-admsb-contactos-tabla [idTitular]="idTitular" [telefonoTitular]="titular?.telefono"
                             [correoTitular]="titular?.correo"></app-admsb-contactos-tabla>

</div>
